export default function prenatalTabs(element) {
    const tabs = Array.from(element.querySelectorAll("[data-prenatal-tab]"));
    const panels = Array.from(element.querySelectorAll("[data-prenatal-panel]"));

    if (!tabs.length || !panels.length) {
        return;
    }

    const activate = (name) => {
        tabs.forEach((tab) => {
            const active = tab.dataset.prenatalTab === name;
            tab.classList.toggle("is-active", active);
            tab.setAttribute("aria-selected", active ? "true" : "false");
            tab.tabIndex = active ? 0 : -1;
        });

        panels.forEach((panel) => {
            const active = panel.dataset.prenatalPanel === name;
            panel.classList.toggle("is-active", active);
            panel.hidden = !active;
        });
    };

    const scrollToElement = () => {
        const header = document.querySelector(".page-header");
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        const top = element.getBoundingClientRect().top + window.pageYOffset - headerHeight - 16;

        window.scrollTo({
            top: Math.max(0, top),
            behavior: "smooth",
        });
    };

    tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => activate(tab.dataset.prenatalTab));
        tab.addEventListener("keydown", (event) => {
            const direction = event.key === "ArrowRight" ? 1 : event.key === "ArrowLeft" ? -1 : 0;

            if (!direction) {
                return;
            }

            event.preventDefault();
            const nextIndex = (index + direction + tabs.length) % tabs.length;
            tabs[nextIndex].focus();
            activate(tabs[nextIndex].dataset.prenatalTab);
        });
    });

    const compositionLinks = Array.from(document.querySelectorAll(".prenatal__banner a")).filter((link) => {
        const href = link.getAttribute("href") || "";
        const text = link.textContent.replace(/\s+/g, " ").trim().toLowerCase();

        return href === "#method-application" || text === "узнать больше о составе";
    });

    compositionLinks.forEach((link) => {
        link.addEventListener("click", (event) => {
            event.preventDefault();
            activate("plant");
            scrollToElement();
        });
    });
}
